import Ahome from '../p_admin/views/Ahome.vue'; // 园区后台 首页

import HomePage from '../p_admin/components/homePage/home.vue'; // 园区后台 首页页面

import Auser from '../p_admin/components/systemPage/auser.vue'; // 园区后台 系统管理 用户管理
import Arole from '../p_admin/components/systemPage/arole.vue'; // 园区后台 系统管理 角色管理
import Apower from '../p_admin/components/systemPage/apower.vue'; // 园区后台 系统管理 角色管理
import Apark from '../p_admin/components/systemPage/apark.vue'; // 园区后台 系统管理 园区管理

import Config from '../p_admin/components/companyPage/config.vue'; // 园区后台 企业管理 企业配置

import Current from '../p_admin/components/reportPage/current.vue'; // 园区后台 报表中心 设备电流
import WarnEvent from '../p_admin/components/reportPage/warnEvent.vue'; // 园区后台 报表中心 告警事件
import WarnSum from '../p_admin/components/reportPage/warnSum.vue'; // 园区后台 报表中心 告警汇总
import Daily from '../p_admin/components/reportPage/daily'; //日报
import Visitor from '../p_admin/components/reportPage/visitor';//民众关注
import Availability from '../p_admin/components/reportPage/availability';//设备完好率
import CurrentWarnSummary from '../p_admin/components/reportPage/currentWarnSummary'; //当前异常汇总


export default [
    {
        path: '/ahome',
        name: 'ahome',
        component: Ahome,
        children: [
            // 首页
            {
                path: '/ahome',
                name: 'homePage',
                component: HomePage
            },
            // 系统管理
            {
                path: '/ahome/auser',
                name: 'auser',
                component: Auser
            },
            {
                path: '/ahome/arole',
                name: 'arole',
                component: Arole
            },
            {
                path: '/ahome/apower',
                name: 'apower',
                component: Apower
            },
            {
                path: '/ahome/apark',
                name: 'apark',
                component: Apark
            },
            // 企业管理
            {
                path: '/ahome/config',
                name: 'config',
                component: Config
            },
            // 报表中心
            {
                path: '/ahome/current',
                name: 'current',
                component: Current
            },
            {
                path: '/ahome/warnEvent',
                name: 'warnEvent',
                component: WarnEvent
            },
            {
                path: '/ahome/warnSum',
                name: 'warnSum',
                component: WarnSum
            },
            {
                path: '/ahome/daily',
                name: 'daily',
                component: Daily
            },
            {
                path: '/ahome/visitor',
                name: 'visitor',
                component: Visitor
            },
            {
                path: '/ahome/availability',
                name: 'Availability',
                component: Availability
            },{
                path: '/ahome/currentWarnSummary',
                name: 'CurrentWarnSummary',
                component: CurrentWarnSummary
            }
        ]
    }
]